module.exports = __webpack_public_path__ + "static/media/VINATI JI 02.fb9a8e58.jpg";